import { translate } from 'loankeeper-common/helpers'
import { LKDate } from 'loankeeper-common/helpers/Date'
import { formName } from './constants'
import { MomentInput } from 'moment'
import { ClientDetailsData } from './types'

type FunctionType = (parameter: string) => string

export const icon: FunctionType = (objectName) => `${formName}/${objectName}`

export const commonIcon: FunctionType = (objectName) => `common/${objectName}`

export const translateWebMessages: FunctionType = (name) => translate(`frm_web_messages-${name}`)
export const translateBase: FunctionType = (name) => translate(formName, name)
export const translateLabel: FunctionType = (name) => translate(formName, `lbl_${name}`)
export const translateCmd: FunctionType = (cmd) => translate(formName, `cmd_${cmd}`)
export const translateCmdPrint: FunctionType = (cmd) => translate('frm_acc_entries', `cmd_${cmd}`)

export const translateTable: (table: string, name: string) => string = (table, name) => translate(formName, `${table}.${name}`)
export const translateLKMessage: FunctionType = (key) => translate(`LKMESSAGE-${key}`)
export const smsSendTranslate: FunctionType = (key) => translate('frm_sms_send', key)
export const translateRel: FunctionType = (key) => translate('frm_client_rl', key)
export const translateNotes: FunctionType = (key) => translate('frm_client_notes_add_edit', key) // TODO: check form name
export const translateDelegates: FunctionType = (key) => translate('frm_client_delegate_add_edit', key)
export const translateActiveNotes: FunctionType = (key) => translate('frm_RMD_All', key)
export const translateIDDoc: FunctionType = (name) => translate(`frm_client_iddoc_add_edit-${name}`)
export const translateCreditInfo : FunctionType = (key) => translate('frm_client_creditinfo', key)

export const getWindowName = (data: ClientDetailsData, ID: string) => `${translateLabel('client_view_cap')} ${data.FullName} (ID ${ID})`


export const getWindowShortName = (data: ClientDetailsData) => data.FullName

export const addDays = (date: MomentInput, days: number) => LKDate.from(LKDate.from(date).instance.clone().add(days, 'days')).toString()

export const getUri = ({ ClientTypeID } : {ClientTypeID: string}, ID: string, hash: string) => `/secure/client/${ID}/details/${hash}/${ClientTypeID}`

